export default {
  sections: {
    title: {
      title: 'Zamówienie potwierdzone',
      description: 'Karta podarunkowa została pomyślnie zakupiona',
    },
    instructions: {
      title: 'Sprawdź swoją skrzynkę e-mail',
      description:
        'Wysłaliśmy szczegóły karty podarunkowej i potwierdzenie na Twój adres e-mail. Kod karty podarunkowej dotrze w ciągu 5–10 minut.',
    },
    details: {
      total: 'Łącznie',
      order_number: 'Numer zamówienia',
    },
    footer: {
      help: 'Nasz partner technologiczny Foodamigos pomaga nam zarządzać kartami podarunkowymi. Jeśli nie otrzymasz karty lub nie możesz jej znaleźć, skontaktuj się z nimi pod adresem {{email}}',
      questions:
        'W przypadku ogólnych pytań dotyczących realizacji skontaktuj się z nami bezpośrednio pod adresem {{email}}',
    },
  },
  buttons: {
    go_home: 'Wróć do strony głównej',
    download_pdfs: 'Pobierz PDF karty podarunkowej',
  },
};
